/**
 * Feed Utility Functions
 * 
 * Helper functions for the feed module
 */

/**
 * Formats location URL from inspection text
 */
export const extractLocationUrl = (text: string): string | null => {
  const locationMatch = text.match(/http:\/\/maps\.google\.com\/\?q=[^\s]+/);
  return locationMatch ? locationMatch[0] : null;
};

/**
 * Truncates text to specified length with ellipsis
 */
export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};

/**
 * Gets relative time string (e.g., "2 jam yang lalu")
 */
export const getRelativeTime = (dateString: string): string => {
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Baru saja';
  if (diffMins < 60) return `${diffMins} menit yang lalu`;
  if (diffHours < 24) return `${diffHours} jam yang lalu`;
  if (diffDays < 7) return `${diffDays} hari yang lalu`;

  return date.toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

/**
 * Formats image URL to full path
 * Handles URLs with or without leading slash to avoid double slashes
 * 
 * @param imageUrl - Relative or absolute image URL
 * @returns Full URL to the image
 * 
 * @example
 * getFullImageUrl('/images/photo.jpg') // 'https://dev-sakti.gbs.id/api/insight/images/photo.jpg'
 * getFullImageUrl('images/photo.jpg')  // 'https://dev-sakti.gbs.id/api/insight/images/photo.jpg'
 * getFullImageUrl('http://example.com/photo.jpg') // 'http://example.com/photo.jpg'
 */
export const getFullImageUrl = (imageUrl: string): string => {
  // If already a full URL, return as is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }

  // Remove leading slash if present to avoid double slashes
  const cleanUrl = imageUrl.startsWith('/') ? imageUrl.slice(1) : imageUrl;

  return `${process.env.REACT_APP_API_URL || 'https://dev-sakti.gbs.id/api/insight'}/${cleanUrl}`;
};
